<template>
  <van-overlay :show="show" @click="hidd()">
    <div class="wrapper">
      <div class="body" @click.stop>
        <div class="title">确定打开小程序</div>
        <div class="layout-row but">
          <div class="div" @click="hidd()">取消</div>
          <div class="div" @click="hidd()">
            <wx-open-launch-weapp
              id="launch-btn"
              :username="info.app_id"
              path="pages/index/index.html"
            >
              <script type="text/wxtag-template">
                          <style>.btn {    font-size: 16px;
                color: #3982f7;
                height: 40px;
                line-height: 40px;
                width: 125px;
                text-align: center; }</style>
                          <div class="btn">确定</div>
              </script>
            </wx-open-launch-weapp>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      var btn = document.getElementById("launch-btn");
      btn.addEventListener("launch", function (e) {
        console.log("success");
      });
      btn.addEventListener("error", function (e) {
        console.log("fail", e.detail);
      });
      console.log(this.info, btn);
    });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        this.hidd();
      } else {
      }
    });
  },
  methods: {
    hidd() {
      this.$store.commit("event/setLaunchWeapp", {
        show: false,
      });
    },
  },
  computed: {
    info() {
      return this.$store.getters["event/getLaunchWeapp"];
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.body {
  .but {
    border-top: 1px solid #f0f0f0;
    .div {
      font-size: 16px;
      color: #666;
      height: 40px;
      line-height: 40px;
      width: 125px;
      text-align: center;
    }
    .div:nth-child(1) {
      border-right: 1px solid #f0f0f0;
    }
  }
  .title {
    padding: 1rem 1.5rem;
    text-align: center;
    font-size: 16px;
    color: #000;
  }
  width: 250px;
  background-color: #fff;
  border-radius: 0.4rem;
}
</style>


// WEBPACK FOOTER //
// src/components/launchWeapp.vue